/**
   *  Loại phương án phân bổ
   */
export default {
  ImplementBeginYear: 1, //Dự toán đầu năm
  ImplementAdditional: 2, //Dự toán điều chỉnh bổ sung
  ImplementAdjustment: 3 //Dự toán điều chỉnh
};
